import React  from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";

import './css/termsofuse.css';
const Tracuuthongtin=()=> {
    const Handleclick =()=>{
        window.history.back();
    }
  return (
   <Layout>
        <div className="container">
        <div className="header row d-flex pdy-10 mgx-0 mgt-10">
            <div className="col-1 in-f" onClick={Handleclick}>
                <i className="fa-solid fa fa-chevron-left"></i>
            </div>
            <div className="col-10 flex-center">
                <span className="text_14 font_700">Phương thức thanh toán</span>
            </div>
            <div className="col-1"></div>
        </div>
          {/* <h1 className='d-none'>Phương thức thanh toán</h1> */}
        <div className='container page-builder-ltr'>
            <div className='container-page-footer'>
                <p><em><strong>&nbsp;</strong></em><em><strong></strong></em></p>
                <p><strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</strong><strong>&nbsp;HƯỚNG DẪN TRA CỨU HÓA ĐƠN ĐIỆN TỬ</strong></p>
                <p><strong>&nbsp; &nbsp; &nbsp; &nbsp;</strong><span><strong> Bước 1</strong><strong>:</strong></span> Truy cập địa chỉ <strong>https://bibomart.com.vn</strong></p>
                <p><strong>&nbsp; &nbsp; &nbsp; &nbsp; <span>Bước 2:</span></strong> Chọn mục <strong>Tra cứu hóa đơn điện tử</strong> ở cuối trang</p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<img lazy src="https://media.bibomart.com.vn/media/wysiwyg/2019/tra-cuu-hoa-don-dien-tu.jpg" data-original="https://media.bibomart.com.vn/media/wysiwyg/2019/tra-cuu-hoa-don-dien-tu.jpg" alt="tra-cuu-hoa-don-dien-tu" width="800" height="212"/></p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp;Chuyển sang địa chỉ <a href="http://hoadon.bibomart.net/" target="_blank"><strong>https://hoadon.bibomart.net</strong></a></p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp;Giao diện trang tra cứu Hóa đơn điện tử:</p>
                <p>&nbsp; &nbsp; &nbsp;&nbsp; <img lazy src="https://media.bibomart.com.vn/media/wysiwyg/Thang_6/tra-cuu-hoa-don-dien-tu_1.jpg" data-original="https://media.bibomart.com.vn/media/wysiwyg/Thang_6/tra-cuu-hoa-don-dien-tu_1.jpg" width="800" height="235"/></p>
                <p><strong>&nbsp; &nbsp; &nbsp; <span>Bước 3:</span></strong> Nhập đầy đủ các thông tin để tra cứu hóa đơn:</p>
                <ul>
                    <li>Số VBILL: Nhập số Bill cần tra cứu</li>
                </ul>
                <ul>
                    <li>Mã xác thực: Nhập dãy số ngẫu nhiên bên phải</li>
                </ul>
                <ul>
                    <li>Bấm nút "Tìm kiếm"</li>
                </ul>
                <p><strong>&nbsp; &nbsp; &nbsp; <span>Bước 4:</span></strong> Chọn biểu tượng "<img lazy="" src="https://media.bibomart.com.vn/media/wysiwyg/2019/icon_xem.jpg" data-original="https://media.bibomart.com.vn/media/wysiwyg/2019/icon_xem.jpg" alt="tra-cuu-hoa-don-dien-tu-2" width="19" height="15"/>" để xem chi tiết hóa đơn:</p>
                <p className='introduction-image'><img lazy src="https://media.bibomart.com.vn/media/wysiwyg/2019/mau-hoa-don-dien-tu_-do_1.jpg" data-original="https://media.bibomart.com.vn/media/wysiwyg/2019/mau-hoa-don-dien-tu_-do_1.jpg" alt="tra-cuu-hoa-don-dien-tu-4" width="600" height="813"/></p>
                <p><strong> &nbsp;<span>Bước 5:</span></strong> Chọn biểu tượng "<img lazy="" src="https://media.bibomart.com.vn/media/wysiwyg/2019/icon_down.jpg" data-original="https://media.bibomart.com.vn/media/wysiwyg/2019/icon_down.jpg" alt="tra-cuu-hoa-don-dien-tu-3" width="16" height="18"/>" để tải bản thể hiện của Hóa đơn điện tử về máy tính.</p>
            </div>
        </div>

        <div className="footer text_13 font_500">
            <div className="row">
                <div className="col-12">
                    <div className="card card-border flex-center-col">
                        <span className="">Mọi thắc mắc, vui lòng liên hệ:</span>
                        <span className="font_700 color_red">P. Chăm sóc Khách hàng</span>
                        <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                        <span className="">Hotline: 1800 6886 (Miễn phí)</span>
                        <span className="">Email: cskh@bibomart.com.vn</span>
                    </div>
                </div>
            </div>
            <div className="row mgt-30">
                <div className="col-12 flex-center-col">
                    <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                    <ul className="mgt-10">
                        <li>Trụ sở: 120 Trần Duy Hưng, Phường Yên Hòa, Thành phố Hà Nội, Việt Nam.</li>
                        <li>Văn phòng Miền Bắc: Tầng 10, Tòa Handico, Đường Phạm Hùng, Phường Từ Liêm, Thành phố Hà Nội. Số điện thoại: (024) 7309 1168</li>
                        <li>Văn phòng Miền Nam: Tầng 3, số 2A Nguyễn Oanh, Phường Hạnh Thông, TP.Hồ Chí Minh, Việt Nam.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
   </Layout>
  )
}
export default Tracuuthongtin;